import bodymovin from 'lottie-web';
import { setEqualHeight } from '../utils/helpers';

export class SolutionFeaturesShortcode {
	constructor() {
		this.registerEventListeners();

		this.titles = document.querySelectorAll(
			'body.single .solution-feature__title'
		);
		if (this.titles.length) {
			setEqualHeight(this.titles);
		}

		this.descriptions = document.querySelectorAll(
			'body.single .solution-feature__description p'
		);
		if (this.descriptions.length) {
			setEqualHeight(this.descriptions);
		}
	}

	registerEventListeners() {
		const container = document.querySelector('.solution-features-wrapper');
		if (!container) {
			return;
		}

		const solutionFeatures =
			container.querySelectorAll('.solution-feature');
		if (!solutionFeatures.length) {
			return;
		}

		[...solutionFeatures].forEach((solutionFeature) => {
			const animationId = solutionFeature.hasAttribute(
				'data-animation-id'
			)
				? solutionFeature.dataset.animationId
				: '';

			const thumbnailStaticContainer =
				solutionFeature.querySelector('.thumbnail-static');
			const thumbnailDynamicContainer =
				solutionFeature.querySelector('.thumbnail-dynamic');
			const direction = 1;

			const animatedItem = bodymovin.loadAnimation({
				container: thumbnailDynamicContainer,
				animType: 'svg',
				loop: false,
				autoplay: false,
				path: AssetsPath.url + `/animations/${animationId}.json`,
				//path: `/wp-content/themes/nayax/resources/animation/${animationId}.json`
			});

			animatedItem.addEventListener('complete', (e) => {
				const direction = solutionFeature.dataset.hasOwnProperty(
					'direction'
				)
					? parseInt(solutionFeature.dataset.direction)
					: 0;
				if (direction === -1) {
					thumbnailStaticContainer.classList.remove('transparent');
				}
			});

			solutionFeature.addEventListener('mouseenter', (e) => {
				thumbnailStaticContainer.classList.add('transparent');
				animatedItem.setDirection(direction);
				solutionFeature.dataset.direction = direction;
				animatedItem.play();
			});

			solutionFeature.addEventListener('mouseleave', (e) => {
				animatedItem.setDirection(-direction);
				solutionFeature.dataset.direction = -direction;
				animatedItem.play();
			});
		});

		window.addEventListener('resize', (e) => {
			if (this.titles.length) {
				setEqualHeight(this.titles);
			}

			if (this.descriptions.length) {
				setEqualHeight(this.descriptions);
			}
		});
	}
}
